/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Checkbox,
  FormControlLabel,
  TextField,
  RadioGroup,
} from '@material-ui/core';
import _, { forIn, groupBy } from 'lodash';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import { DisputeCodesDisplay } from './TableHead';
import PaginationBox from './PaginationBox';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import {
  getDisputeCodeReport,
  getCodeExportAll,
  setPaginationIndex,
} from '../Store/action';
import { exportAllPDF } from './exportAll';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';

const DisplayDisputeCodes = () => {
  const {
    displayObj: {
      allCode: codeData,
      allManufacturer: manufactureData,
      rebateProgramName: getRebateProgramName,
      manufactureWithIds: manufactureID,
      selectedValue: manufactureValue,
      disputeCodeReport: disputeCodeReportList,
      selectedOptionDisputeCode: selectedDisputeCodeOptionList,
      drugSelection: selectedDrugValue,
      startQtr: startQtrValue,
      endQtr: endQtrValue,
      manufacturerList: resultManufacturerGrid,
      countValue,
    },

    open,
    closed,

    exportAllData,
  } = useSelector((state) => state?.sharedState?.DisputeCodeReducer);
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const disputeCodeReport = useSelector(
    (state) => state?.sharedState?.DisputeCodeReducer?.disputeCodeReport
  );
  const dispatch = useDispatch();
  const [fullScreenView, setFullScreenView] = useState(false);
  const [disputeCode, setDisputeCode] = useState();
  const [isExportAllClick, setIsExportAllClick] = useState(false);
  const [error, setError] = useState([]);
  const [columnApi, setColumnApi] = React.useState(null);

  // pagination
  const paginationLength = selectedDisputeCodeOptionList?.length;
  const [count, setCount] = useState(countValue);
  const [paginationArray, setPaginationArray] = useState([
    ...Array(paginationLength).keys(),
  ]);

  useEffect(() => {
    setCount(countValue || 1);
  }, [countValue]);
  // To handle next and previous button of pagination
  const handleClick = (type, value) => {
    if (type === 'next') {
      dispatch(setPaginationIndex(count + 1));
    }

    if (type === 'previous') {
      dispatch(setPaginationIndex(count - 1));
    }

    if (type === 'change') {
      if (value < 1 || value > paginationArray.length) {
        dispatch(setPaginationIndex(paginationArray.length));
      } else {
        dispatch(setPaginationIndex(value));
      }
    }
  };
    
  // TO handle any changes in the pagination text field
  const handleBlur = (value) => {
    const numericValue = parseInt(value);
    let correctedValue = 1;
    if (isNaN(numericValue) || value === '' || numericValue < 1) {
      dispatch(setPaginationIndex(1));
    } else if (numericValue > paginationArray.length) {
      dispatch(setPaginationIndex(paginationArray.length));
      correctedValue = paginationArray.length;
    } else {
      dispatch(setPaginationIndex(numericValue));
      correctedValue = numericValue;
    }
      return correctedValue;
  };
  
  // handling full screen view
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };

  // short description
  const short = selectedDisputeCodeOptionList?.map(
    (obj) => obj.shortDescription
  );
  // dispute code
  const disputeCd = selectedDisputeCodeOptionList?.map(
    (obj) => obj.codeValuetemp
  );

  // mfg type
  const type = manufactureData?.map((obj) => obj.mfgTypeCd);
  // mfg ID
  const mID = manufactureData?.map((obj) => obj.mfgId);

  // current quarter
  const today = new Date();
  const quarter = Math.floor(today.getMonth() / 3) + 1;
  const year = today.getFullYear();
  const quarterString = quarter.toString();
  const yearString = year.toString();
  const formattedQuarter = quarterString.padStart(2);

  const currentQuarterWithYear = `${formattedQuarter}Q${yearString}`;

  // pdf header
  let firstInfo = '';
  let secondInfo = '';
  let thirdInfo = '';
  const fourthInfo = '';
  let fifthInfo = '';
  firstInfo = `Selection Basis :${selectedDrugValue} `;
  secondInfo = `Period: ${startQtrValue} to ${
    endQtrValue || currentQuarterWithYear
  }`;
  thirdInfo = `${`${getRebateProgramName?.rebateProgramCd} - ${getRebateProgramName?.shortDescr}`}`;
  // fourthInfo = `Description: ${short[count - 1]}`;
  fifthInfo = `Dispute Code: ${disputeCd[count - 1]}`;

  // selection basis
  const drugSelectionBasis = {
    Dispute: {
      disputeType1Cd: ['D'],
      disputeType2Cd: ['$'],
    },

    Adjustment: { disputeType1Cd: ['A'], disputeType2Cd: ['$'] },
    Both: {
      disputeType1Cd: ['A'],
      disputeType2Cd: ['D'],
    },
  };

  // dispute code report
  // useEffect(() => {
  //   setDisputeCode(disputeCodeReportList?.disputeCodeReportVO);
  // }, [disputeCodeReportList]);
  useEffect(() => {
    // dispatch(
    //   getDisputeCodeReport({
    //     programCd: getRebateProgramName?.rebateProgramCd,
    //     mfgId:
    //       manufactureValue == '-1'
    //         ? ['-1']
    //         : mID?.length ==
    //           resultManufacturerGrid?.rebatePercentOfSpendMfgGridVO?.length
    //         ? ['-1']
    //         : mID,
    //     mfgType: type[0],
    //     beginQtr: startQtrValue,
    //     endQtr: endQtrValue || currentQuarterWithYear,
    //     adjustDisputeCd: [disputeCd[count - 1]],
    //     disputeType1Cd: drugSelectionBasis[selectedDrugValue].disputeType1Cd,
    //     disputeType2Cd: drugSelectionBasis[selectedDrugValue].disputeType2Cd,
    //     openStatus: open ? 1 : 0,
    //     closeStatus: closed ? 1 : 0,
    //   })
    // );
    if (count) {
      const data = Object.groupBy(
        disputeCodeReport.disputeCodeReportVO,
        ({ disputeCode }) => disputeCode
      );
      const code = disputeCd[count - 1];
      const newData = data?.[code]?.map((item) => {
        const currentAmtDue =
          Number(item.unitRebateAmt) * Number(item.noOfUnits);
        let balanceDue = currentAmtDue - Number(item.paidAmt);
        balanceDue = parseFloat(balanceDue.toFixed(4));

        return {
          ...item,
          currentAmtDue,
          balanceDue,
        };
      });
      newData.sort((a, b) => {
        return a.mfgName.localeCompare(b.mfgName);
      });
      setDisputeCode(newData);
    }
  }, [count]);

  // business logic
  // useEffect(() => {
  //   const data = disputeCodeReportList?.disputeCodeReportVO || [];
  //   const newData = data?.map((item) => {
  //     const currentAmtDue = Number(item.unitRebateAmt) * Number(item.noOfUnits);
  //     let balanceDue = currentAmtDue - Number(item.paidAmt);
  //     balanceDue = parseFloat(balanceDue.toFixed(2));

  //     return {
  //       ...item,
  //       currentAmtDue,
  //       balanceDue,
  //     };
  //   });
  //   newData.sort((a, b) => {
  //     return a.mfgName.localeCompare(b.mfgName);
  //   });
  //   setDisputeCode(newData);
  // }, [disputeCodeReportList]);

  const [exportFileName, setExportFileName] = React.useState(null);
  const exportAllTpPDF = (name) => {
    setExportFileName(name);
    setIsExportAllClick(true);
    const dipCode = disputeCd[count - 1];
    dispatch(
      getCodeExportAll(
        {
          programCd: getRebateProgramName?.rebateProgramCd,
          mfgId:
            manufactureValue == '-1'
              ? ['-1']
              : mID?.length ==
                resultManufacturerGrid?.rebatePercentOfSpendMfgGridVO?.length
              ? ['-1']
              : mID,
          mfgType: type[0],
          beginQtr: startQtrValue,
          endQtr: endQtrValue || currentQuarterWithYear,
          adjustDisputeCd: [dipCode],
          disputeType1Cd: drugSelectionBasis[selectedDrugValue].disputeType1Cd,
          disputeType2Cd: drugSelectionBasis[selectedDrugValue].disputeType2Cd,
          openStatus: open ? 1 : 0,
          closeStatus: closed ? 1 : 0,
        },
        selectedDisputeCodeOptionList
      )
    );
  };
  const onGridReady = (params) => {
    setColumnApi(params.columnApi);
  };
  useEffect(() => {
    if (isExportAllClick) {
      if (Object.keys(exportAllData).length === 2) {
        setIsExportAllClick(false);
        let data = [];
        for (const key in exportAllData) {
          exportAllData[key].sort((a, b) => {
            return a.mfgName.localeCompare(b.mfgName);
          });
          data = [...data, ...exportAllData[key]];
        }

        data = data.map((item) => {
          const currentAmtDue =
            Number(item.unitRebateAmt) * Number(item.noOfUnits);
          const balanceDue = currentAmtDue - Number(item.paidAmt);
          return {
            ...item,
            ndc: `${item.labelerCode}-${item.productCode}-${item.packageSize}`,
            balanceDue: balanceDue || 0.0,
            paidAmt: item.paidAmt ? item.paidAmt : 0.0,
            currentAmtDue: currentAmtDue || 0.0,

            unitRebateAmt: item.unitRebateAmt
              ? item.unitRebateAmt.toFixed(4)
              : '0.0000',
            mostRecentUra: item.mostRecentUra
              ? item.mostRecentUra.toFixed(4)
              : '0.0000',
            noOfUnits: item.noOfUnits ? item.noOfUnits.toFixed(4) : '0.0000',
            paidUnits: item.paidUnits ? item.paidUnits.toFixed(4) : '0.0000',
          };
        });

        // Sort the data by the ndc key
        data.sort((a, b) => a.ndc.localeCompare(b.ndc));

        const groupedData = groupBy(data, 'disputeCode');

        const header = {
          reportName: 'Dispute Code Report',
          fileName: exportFileName,
        };
        const mapping = {};

        const options = {
          titleName: 'Dispute Code: ',
          info: { thirdInfo },
          pageSize: { height: 700, width: 1090 },
          mapping,
        };
        const paginationArr = Object.keys(groupedData)?.sort();
        const tableHeads = DisputeCodesDisplay.filter(
          (item) => !item.removeColumn
        );
        // let optDisputeCode = selectedDisputeCodeOptionList?.map((v, i) => ({
        //   shortDescription: v.shortDescription,
        //   codeValuetemp: v.codeValuetemp,
        // }));
        // optDisputeCode = optDisputeCode?.filter((l) =>
        //   _.includes(paginationArr, l.codeValuetemp)
        // );
        const optDisputeCode = selectedDisputeCodeOptionList
          ?.map((v) => ({
            shortDescription: v.shortDescription,
            codeValuetemp: v.codeValuetemp,
          }))
          .filter((code) => paginationArr.includes(code.codeValuetemp));
        const widths = [70, 315, 50, 70, 70, 70, 70, 70, 70, 70];
        exportAllPDF(
          header,
          groupedData,
          columnApi,
          userDefaults,
          options,
          paginationArr,
          widths,
          logInUser,
          optDisputeCode
        );
      }
    }
  }, [exportAllData]);

  return (
    <div className="tabs-contaitBillPanel custom-check tabs-container">
      <Spinner load={spinnerLoader} />
      <DisplayErrorMessages errorMessages={error?.map((l) => l)} />
      <CustomSeparator
        parent1="Summary Reports"
        parent2="Display Dispute Code Summary"
      />{' '}
      <div className="tab-body">
        {!fullScreenView && (
          <>
            <div className="row mb-5">
              <div className="col-12">
                <PaginationBox
                  array={paginationArray}
                  count={count}
                  handleClick={handleClick}
                  handleBlur={handleBlur}
                />
              </div>
            </div>
            <div className="panel custom-fieldset">
              <div className="custom-check">
                <div className="form-wrapper">
                  <div className="mui-custom-form input-md">
                    <div className="col-12">
                      <TextField
                        id="Dispute_Code"
                        label="Dispute Code"
                        fullWidth
                        placeholder=""
                        inputProps={{ id: 'Dispute_Code' }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={disputeCd[count - 1]}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="mui-custom-form input-md">
                    <div className="col-12">
                      <TextField
                        id="Rebate_Program"
                        label="Rebate Program"
                        fullWidth
                        placeholder=""
                        inputProps={{ id: 'Rebate_Program' }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={`${getRebateProgramName?.rebateProgramCd} - ${getRebateProgramName?.shortDescr}`}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="mui-custom-form input-md">
                    <div className="col-12">
                      <TextField
                        label="Selection Basis "
                        fullWidth
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        id="Selection_Basis"
                        inputProps={{ id: 'Selection_Basis' }}
                        value={selectedDrugValue}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="mui-custom-form input-md">
                    <div className="col-12">
                      <TextField
                        label="Description"
                        id="Description1"
                        fullWidth
                        placeholder=""
                        inputProps={{ id: 'Description1' }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        disabled
                        value={short[count - 1]}
                      />
                    </div>
                  </div>

                  <div className="mui-custom-form input-md">
                    <div className="col-12">
                      <TextField
                        id="Start_Quarter"
                        label="Start Quarter"
                        fullWidth
                        placeholder=""
                        inputProps={{ id: 'Start_Quarter' }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={startQtrValue}
                        disabled
                      />
                    </div>
                  </div>

                  <div className="mui-custom-form input-md">
                    <div className="col-12">
                      <TextField
                        id="End_Quarter"
                        label="End Quarter"
                        fullWidth
                        placeholder=""
                        inputProps={{ id: 'End_Quarter' }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={endQtrValue || currentQuarterWithYear}
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        <div className="panel-body FRR-custom-table tbl-manufacturer-inner">
          <TableGrid
            data-testid="dispute-code-table-head"
            fullScreenView={fullScreenView}
            gridCall={onGridReady}
            handleFullScreenViewClick={handleFullScreenView}
            rowSelection="single"
            countValue={count}
            rowMultiSelectWithClick={false}
            columnDefs={DisputeCodesDisplay}
            rowData={disputeCode?.map((item) => {
              return {
                ...item,
                ndc: `${item.labelerCode}-${item.productCode}-${item.packageSize}`,
                balanceDue: item.balanceDue
                  ? item.balanceDue.toFixed(2)
                  : '0.00',

                paidAmt: item.paidAmt ? item.paidAmt.toFixed(2) : '0.00',

                currentAmtDue: item.currentAmtDue
                  ? item.currentAmtDue.toFixed(2)
                  : '0.00',

                unitRebateAmt: item.unitRebateAmt
                  ? item.unitRebateAmt.toFixed(4)
                  : '0.0000',
                mostRecentUra: item.mostRecentUra
                  ? item.mostRecentUra.toFixed(4)
                  : '0.0000',
                noOfUnits: item.noOfUnits
                  ? item.noOfUnits.toFixed(4)
                  : '0.0000',
                paidUnits: item.paidUnits
                  ? item.paidUnits.toFixed(4)
                  : '0.0000',
              };
            })}
            defaultCol={{
              wrapHeaderText: true,

              autoHeaderHeight: true,
            }}
            gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
            exportFile
            animateRows
            sideBar={false}
            fileName="DISPUTECODE"
            reportName="Dispute Code Report"
            isScrollOn
            singleClickEdit
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            onCellFocused={onCellFocused}
            exportAllTpPDF={exportAllTpPDF}
            info={{ firstInfo, secondInfo, thirdInfo, fifthInfo }}
            frameworkComponents={{
              TextBoxRender: (cellInfo) => {
                const name = cellInfo?.value;
                if (name && name.length > 20) {
                  return (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                    >
                      <div>{name}</div>
                    </OverlayTrigger>
                  );
                }
                return <div>{name}</div>;
              },
            }}
          />{' '}
        </div>{' '}
      </div>
    </div>
  );
};

export default DisplayDisputeCodes;
